export const providersOption = [
    { value: 0, name: 'Microsoft' },
    // { value: 1, name: 'Google' },
    // { value: 2, name: 'Facebook' },
];
export const providerTableWrapperStyles = {
    '& .chakra-stack': {
        height: '62px',
        width: 'full',
        px: '20px',
        '& .chakra-stack': {
            px: 0,
        },
        '&+.chakra-stack': {
            display: 'none',
        },
    },
};

export const BUTTON_WIDTH = '100px';

export const initialState = {
    isEnabled: false,
    providers: [],
    isEnforced: false,
};
